import Model from './Model';

export default class YoutubeApiSettings extends Model
{
    resource() {
        return 'youtube_settings';
    }
}
